import { render, staticRenderFns } from "./EpicMappingList.vue?vue&type=template&id=5aa9e139"
import script from "./EpicMappingList.vue?vue&type=script&lang=js"
export * from "./EpicMappingList.vue?vue&type=script&lang=js"
import style0 from "./EpicMappingList.vue?vue&type=style&index=0&id=5aa9e139&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports